import { NgModule } from "@angular/core";
import { FreezingTabDirective } from "./freezing-tab.directive";

@NgModule({
    declarations: [FreezingTabDirective],
    exports: [FreezingTabDirective]
})
export class FreezingTabModule {

}